import { Controller } from "@hotwired/stimulus"

/**
 * The Video Crop controller orchestrates communication between a
 * `Ui::YoutubeVideoComponent` and a `Ui::Form::Inputs::TimeRangeComponent`,
 * primarily triggering start/end seeking behavior in the video component
 * when the time range changes in response to user input.
 *
 * Example:
 *
 *   <div
 *     data-controller="ui--video-crop"
 *     data-action="
 *       ui--form--inputs--time-range:start->ui--video-crop#startChanged \
 *       ui--form--inputs--time-range:end->ui--video-crop#endChanged"
 *     data-ui--video-crop-ui--youtube-video-outlet=".youtube-video"
 *   />
 */
export default class extends Controller {
  static outlets = ["ui--youtube-video"]

  endChanged = ({ detail: { value } }) => {
    if (this.videoOutletReady) {
      this.uiYoutubeVideoOutlet.seek(value)
    }
  }

  startChanged = ({ detail: { value } }) => {
    if (this.videoOutletReady) {
      this.uiYoutubeVideoOutlet.seek(value)
    }
  }

  get videoOutletReady() {
    return this.hasUiYoutubeVideoOutlet && this.uiYoutubeVideoOutlet.readyValue
  }
}
